import { useEffect, useState } from "react";
import { Box, HBox } from "../box/Box";
import { InfoButton } from "../info/InfoButton";
import { Typo, TypoSmall } from "../text/Typo";
import { RecursiveCSS } from "../theme/GlobalTheme";

export const Checkbox = (params: {
	name?: string;
	label?: string;
	disabled?: boolean;
	data?: any;
	onChange?: (checked: boolean) => void;
	sx?: RecursiveCSS;
	size?: "small" | "medium";
	description?: string;
	checked?: boolean;
}) => {
	const [checked, setChecked] = useState<boolean>(
		params.checked !== undefined
			? params.checked
			: params.data && typeof params.data === "object" && params.name && typeof params.name === "string"
			? params.data[params.name]
			: false
	);

	useEffect(() => {
		if (params.checked !== undefined) {
			setChecked(params.checked);
		}
	}, [params.checked]);

	let size = params.size || "medium";

	let boxSize = 20;
	if (size === "small") boxSize = 15;

	const content = (
		<Box
			sx={{
				flexShrink: "0",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
				border: "1px solid rgba(0,0,0,.25)",
				borderRadius: "5px",
				backgroundColor: "#FFFFFF", //"#F2F2F2",
				transition: "background-color .2s, border .2s",
				width: `${boxSize}px`,
				height: `${boxSize}px`,
				cursor: params.disabled ? undefined : "pointer",
				pointerEvents: params.disabled ? "none" : undefined,
				"&:hover": {
					border: params.disabled ? undefined : "1px solid #35539f",
					transition: "border .2s",
				},
			}}
			onClick={() => {
				const newVal = !checked;
				setChecked(newVal);
				if (params.data && typeof params.data === "object" && params.name && typeof params.name === "string") params.data[params.name] = newVal;
				if (params.onChange) params.onChange(newVal);
			}}>
			{checked && (
				<Box
					sx={{
						width: `${Math.round(boxSize) / 2}px`,
						height: `${Math.round(boxSize / 2)}px`,
						backgroundColor: "#201d1d",
						borderRadius: "3px",
					}}></Box>
			)}
		</Box>
	);

	if (!params.label) return content;

	return (
		<Box
			sx={{
				display: "flex",
				gap: "15px",
				alignItems: "center",
			}}>
			{content}
			<HBox sx={{ alignItems: "center", gap: "10px" }}>
				{params.sx ? (
					<Typo
						variant="medium"
						onClick={() => {
							if (params.disabled) return;
							const newVal = !checked;
							setChecked(newVal);
							if (params.data && typeof params.data === "object" && params.name && typeof params.name === "string")
								params.data[params.name] = newVal;
							if (params.onChange) params.onChange(newVal);
						}}
						sx={{ cursor: params.disabled ? "default" : "pointer", whiteSpace: "preserve-breaks", ...params.sx }}>
						{params.label}
					</Typo>
				) : (
					<TypoSmall
						onClick={() => {
							if (params.disabled) return;
							const newVal = !checked;
							setChecked(newVal);
							if (params.data && typeof params.data === "object" && params.name && typeof params.name === "string")
								params.data[params.name] = newVal;
							if (params.onChange) params.onChange(newVal);
						}}
						sx={{
							cursor: params.disabled ? "default" : "pointer",
						}}>
						{params.label}
					</TypoSmall>
				)}
				{params.description && <InfoButton text={params.description} />}
			</HBox>
		</Box>
	);
};
